export const createPuzzle = (from, to, san, moveList, moveCount) => {
  // Construct the new move in the format 'from' + 'to' (e.g., 'd7d5')
  let move = `${from}${to}`;

  // Check if the SAN contains a promotion (e.g., 'e8=Q')
  const promotionMatch = san.match(/=([qrnbQRNB])/);
  if (promotionMatch) {
    const promotedPiece = promotionMatch[1].toLowerCase(); // Convert to lowercase
    move += promotedPiece; // Append to move string
  }

  // Increment the ply (move count) for the new move
  const ply = moveCount;

  // Create the new move object
  const newMoveObject = {
    ply, // Current move count (ply)
    move, // The new move in algebraic notation
    comment: '', // Empty comment (can be added later)
    variations: [], // Empty variations (can be added later)
  };

  // Return the updated move list and the incremented move count
  return {
    updatedMoveList: [...moveList, newMoveObject], // Updated move list
    updatedMoveCount: moveCount + 1, // Incremented move count
  };
};

// // Sample input
// const result = createPuzzle(
//   'd7',
//   'd5',
//   [{ply: 1, move: 'd1d5', comment: '', variations: []}],
//   2,
// );

// console.log(result);
